import { Carriers } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import * as z from "zod/v4";

export const getOriginAddresses = {
  name: "getOriginAddresses" as const,
  input: z.object({ carrier: z.enum(Carriers) }),
  output: z.object({
    addresses: z.array(
      FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
    ),
  }),
};
